import { render, staticRenderFns } from "./SoftSales.vue?vue&type=template&id=92a8df48"
import script from "./SoftSales.vue?vue&type=script&lang=js"
export * from "./SoftSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92a8df48')) {
      api.createRecord('92a8df48', component.options)
    } else {
      api.reload('92a8df48', component.options)
    }
    module.hot.accept("./SoftSales.vue?vue&type=template&id=92a8df48", function () {
      api.rerender('92a8df48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/SoftSales.vue"
export default component.exports